/* tslint:disable */
/* eslint-disable */
/**
 * EN.ClientContract
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * PredictionApi - axios parameter creator
 * @export
 */
export const PredictionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export scheduled production, consumption.
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSchedule: async (date: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('exportSchedule', 'date', date)
            const localVarPath = `/api/Prediction/ExportSchedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication XApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (date !== undefined) {
                localVarQueryParameter['Date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredictionApi - functional programming interface
 * @export
 */
export const PredictionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredictionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export scheduled production, consumption.
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSchedule(date: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSchedule(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PredictionApi - factory interface
 * @export
 */
export const PredictionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredictionApiFp(configuration)
    return {
        /**
         * 
         * @summary Export scheduled production, consumption.
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSchedule(date: string, options?: any): AxiosPromise<any> {
            return localVarFp.exportSchedule(date, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for exportSchedule operation in PredictionApi.
 * @export
 * @interface PredictionApiExportScheduleRequest
 */
export interface PredictionApiExportScheduleRequest {
    /**
     * 
     * @type {string}
     * @memberof PredictionApiExportSchedule
     */
    readonly date: string
}

/**
 * PredictionApi - object-oriented interface
 * @export
 * @class PredictionApi
 * @extends {BaseAPI}
 */
export class PredictionApi extends BaseAPI {
    /**
     * 
     * @summary Export scheduled production, consumption.
     * @param {PredictionApiExportScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredictionApi
     */
    public exportSchedule(requestParameters: PredictionApiExportScheduleRequest, options?: any) {
        return PredictionApiFp(this.configuration).exportSchedule(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }
}
